import { handleActions } from 'redux-actions';
import { LIGHTBOX_SHOW, LIGHTBOX_CLOSE } from '../actions/lightbox';

const initialState = false;

export default handleActions({
  [LIGHTBOX_SHOW]() {
    return true;
  },
  [LIGHTBOX_CLOSE]() {
    return false;
  },
}, initialState);
